import React, { KeyboardEventHandler, useEffect, useState } from "react";
import { ActionMeta, MultiValue, StylesConfig } from "react-select";

import { useSelector } from "react-redux";
import AsyncCreatableSelect from "react-select/async-creatable";
import CreatableSelect from "react-select/creatable";
import configs from "../../../configs/config";
import { getSearchDropdownValues } from "../../../redux/actions/ContactManagement/Contact";
import { IState } from "../../../redux/reducers/rootReducers";
import { useTheme } from "@mui/material/styles";

const components = {
  DropdownIndicator: null,
};

interface Option {
  readonly label: string;
  readonly value: string;
}

const createOption = (label: string) => ({
  label,
  value: label,
});

const CustomCreatableSelect = ({
  width,
  placeholder,
  isMulti,
  handleInputChange,
  defaultValue,
  options,
  name,
}: {
  width: any;
  placeholder: any;
  isMulti: any;
  handleInputChange: any;
  defaultValue: any;
  options: any;
  name: any;
}) => {
  const theme = useTheme();
  const [inputValue, setInputValue] = React.useState("");
  const [value, setValue] = React.useState<readonly Option[]>(defaultValue);
  // const classes = useStyles();

  useEffect(() => {
    handleInputChange(value);
  }, [value]);

  const customStyles: StylesConfig<any> = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "white",
      width: width,
      minWidth: width,
      height: "auto",
      minHeight: 53,

      ":hover": {
        border: "1px solid black",
      },
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    container: (provided, state) => ({
      ...provided,
      fontFamily: "'DM Sans', sans-serif !important",
      fontSize: "14px",
    }),
    placeholder: (styles) => ({ ...styles, fontWeight: 400, color: "#c8c8c8" }),
  };

  const customStyles1: StylesConfig<any> = {
    control: (styles, state) => ({
      ...styles,
      backgroundColor: "white",
      width: width,
      minWidth: width,
      height: "auto",
      minHeight: 53,
      border: "none",
      borderRadius: "0x",
      borderBottom: "0.3px solid grey",
      borderColor: state.isFocused ? "grey !important" : "grey !important",
      boxShadow: "none",
      // "input:focus":{
      //   border: "none",
      // },
      // ".input:hover":{
      //   border: "none",
      //   borderColor:"transparent"
      // },
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    container: (provided, state) => ({
      ...provided,
      fontFamily: "'DM Sans', sans-serif !important",
      fontSize: "14px",
    }),

    placeholder: (styles) => ({ ...styles, fontWeight: 400, color: "#c8c8c8" }),
  };

  const handleKeyDown: KeyboardEventHandler = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        setValue((prev) => [...prev, createOption(inputValue)]);
        setInputValue("");
        event.preventDefault();
    }
  };

  return (
    // <CreatableSelect
    // placeholder={placeholder && placeholder}
    //   components={components}
    //   styles={customStyles }
    //   // inputValue={inputValue}
    //   options={options}
    //   isClearable
    //   isMulti={isMulti}
    //   menuIsOpen={false}
    //   onChange={(newValue : any) => {setValue(newValue)
    //     console.log('selected create setValue ', newValue)}}

    //   // onInputChange={(newValue : any) =>{ setInputValue(newValue);
    //   //   console.log('selected create setInputValue', newValue)}}
    //   // onKeyDown={handleKeyDown}
    //   // value={value}
    // />
    <CreatableSelect
      placeholder={placeholder && placeholder}
      isMulti={isMulti}
      options={options}
      styles={
        name == "to" || name == "bcc" || name == "cc"
          ? customStyles1
          : customStyles
      }
      onChange={(e: any) => {
        handleInputChange(e);
      }}
      value={defaultValue}
      className="add-additional-fields"
    />
  );
};

type OptionType = {
  label: string;
  value: string;
};

interface AProps {
  placeholder: string;
  name: string;
  handleInputChange: any;
  defaultValue: any;
}
export const AsyncCreatableMultiSelect: React.FC<AProps> = (props: AProps) => {
  const theme = useTheme();
  const {
    // placeholder = "Select or create options...",
    placeholder = "",
    name = "",
    handleInputChange,
    defaultValue = [],
  } = props;
  const [inputValue, setInputValue] = useState<string>("");
  const [selectedOptions, setSelectedOptions] =
    useState<MultiValue<OptionType>>(defaultValue);
  const [agentOptions, setAgentOptions] = useState([]);
  const agentList = useSelector(
    (state: IState) => state?.TicketsReducer?.allResponses?.agentsPerRole
  );
  const loadOptions = (
    inputValue: string,
    callback: (options: OptionType[]) => void
  ): void => {
    if (inputValue.length < 3) {
      callback([]);
      return;
    }
    let contactList: OptionType[] = [];
    getSearchDropdownValues(`${configs.BASE_URL}/Contacts`, 1, true, inputValue)
      .then((res) => {
        const temp = [];
        res.map((i: any) => {
          const {
            id,
            isVIP,
            name = "",
            email,
            knownAs,
            profilePicturePath,
          } = i;
          if (!email) return;
          temp.push({
            id,
            isVIP,
            name,
            email,
            knownAs,
            profilePicturePath,
            value: email,
            label: email,
          });
        });

        temp.push(
          agentOptions.filter((i: { label: string }) =>
            i.label.toLowerCase().includes(inputValue.toLowerCase())
          )
        );
        callback(temp.flat());
      })
      .catch((err) => {
        console.warn("getSearchDropdownValues", err);
        callback(contactList);
      });
  };
  useEffect(() => {
    if (agentList?.map) {
      const tempArr: any = [];
      agentList.map((i: any) => {
        if (!i.email) return;
        tempArr.push({
          label: i.email,
          value: i.email,
        });
      });
      setAgentOptions(tempArr);
    }
  }, [agentList?.length]);
  const handleCreate = (inputValue: string): void => {
    const newOption: OptionType = { label: inputValue, value: inputValue };
    setSelectedOptions((prev) => [...prev, newOption]);
  };

  const handleChange = (
    newValue: MultiValue<OptionType>,
    _actionMeta: ActionMeta<OptionType>
  ): void => {
    setSelectedOptions(newValue);
  };
  useEffect(() => {
    if (handleInputChange) handleInputChange(selectedOptions);
  }, [selectedOptions]);
  const highlightMatch = (
    label: string,
    input: string
  ): JSX.Element | string => {
    const index = label.toLowerCase().indexOf(input.toLowerCase());
    if (index === -1 || !input) return label;

    return (
      <>
        {label.slice(0, index)}
        <span style={{ backgroundColor: theme.palette.mode === "light" ? "#ffff00" : "#90caf96b", fontWeight: "bold" }}>
          {label.slice(index, index + input.length)}
        </span>
        {label.slice(index + input.length)}
      </>
    );
  };

  const emailContactFieldStyle = useEmailContactFieldStyle();
  return (
    <AsyncCreatableSelect
      isMulti
      cacheOptions
      defaultOptions
      loadOptions={loadOptions}
      onCreateOption={handleCreate}
      onChange={handleChange}
      value={selectedOptions}
      isClearable
      name={name}
      className="new-email-createable-field"
      styles={emailContactFieldStyle}
      placeholder={placeholder}
      onInputChange={(value) => {
        setInputValue(value);
        return value;
      }}
      formatOptionLabel={(option) => highlightMatch(option.label, inputValue)}
    />
  );
};





export const useEmailContactFieldStyle = (): StylesConfig<any> => {
  const theme = useTheme();

  return {
    control: (styles, state) => ({
      ...styles,
      backgroundColor: theme.palette.mode === "light" ? "white" : "#3f4044",
      width: "100%",
      minWidth: "100%",
      height: "auto",
      minHeight: 53,
      border: "none",
      borderBottom: "0.3px solid grey",
      borderRadius: 0, // you had "0x", changed to a valid 0
      borderColor: state.isFocused ? "grey" : "grey",
      boxShadow: "none",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    container: (provided) => ({
      ...provided,
      fontFamily: "'DM Sans', sans-serif",
      fontSize: "14px",
    }),
    placeholder: (styles) => ({
      ...styles,
      fontWeight: 400,
      color: theme.palette.mode === "light" ? "#666" : "#c8c8c8",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: theme.palette.mode === "light" ? "#000" : "#fff",
    }),
    option: (styles, state) => ({
      ...styles,
      backgroundColor: state.isFocused
        ? theme.palette.mode === "light" ? "#f0f0f0" : "#505050"
        : "transparent",
      color: theme.palette.mode === "light" ? "#000" : "#fff",
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: theme.palette.mode === "light" ? "#fff" : "#3f4044",
    }),
    input: (styles) => ({
      ...styles,
      color: theme.palette.mode === "light" ? "#000" : "#fff",
    }),
    
    valueContainer: (styles) => ({
      ...styles,
      color: theme.palette.mode === "light" ? "#000" : "#fff",
    }),

    multiValue: (styles) => ({
      ...styles,
      backgroundColor: theme.palette.mode === "light" ? "#e0e0e0" : "#5a5a5a",
    }),
    
    multiValueLabel: (styles) => ({
      ...styles,
      color: theme.palette.mode === "light" ? "#333" : "#fff",
    }),
    
    multiValueRemove: (styles) => ({
      ...styles,
      color: theme.palette.mode === "light" ? "#555" : "#fff",
      ':hover': {
        backgroundColor: theme.palette.mode === "light" ? "#ccc" : "#777",
        color: theme.palette.mode === "light" ? "#000" : "#fff",
      },
    }),    
  };
};

export default CustomCreatableSelect;
